import { Card, Col, Row } from "antd";
import dayjs from "dayjs";
import spacing from "../../../components/ui/spacingConfig";
import type { Event } from "../../../types/events";
import { UserForList } from "../../../types/user";

type Props = {
  eventData: Event | undefined;
  pilote: UserForList;
  className?: string;
};

const CardPiloteGravity: React.FC<Props> = ({
  eventData,
  pilote,
  className,
}) => {
  return (
    <Card title="Pilote et gravitÃ©" bordered={false} className={className}>
      <Row gutter={spacing.s}>
        <Col span={spacing.xs}>
          <p className="text-light-grey">Pilote</p>
        </Col>
        <Col span={spacing.xs}>
          <p className="text-light-blue">{pilote.fullname}</p>
        </Col>
      </Row>
      <Row gutter={spacing.s}>
        <Col span={spacing.xs}>
          {" "}
          <p className="text-light-grey">GravitÃ©</p>
        </Col>
        <Col span={spacing.xs}>
          <p>{eventData?.gravity}</p>
        </Col>
      </Row>
      <Row gutter={spacing.s}>
        <Col span={spacing.xs}>
          {" "}
          <p className="text-light-grey">ThÃ©matique</p>
        </Col>
        <Col span={spacing.xs}>
          <p className="text-light-blue">
            {eventData?.theme?.code} -{" "}
            {eventData?.theme?.description || "Pas de description"}
          </p>
        </Col>
      </Row>
      <Row gutter={spacing.s}>
        <Col span={spacing.xs}>
          {" "}
          <p className="text-light-grey">Date d'Ã©chÃ©ance</p>
        </Col>
        <Col span={spacing.xs}>
          <p>
            {eventData?.dateAsked
              ? dayjs(eventData.dateAsked).format("DD/MM/YYYY")
              : ""}
          </p>
        </Col>
      </Row>
    </Card>
  );
};

export default CardPiloteGravity;
